// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmPayoutDialog-BankCard_cls1__ApaZl","cls2":"ConfirmPayoutDialog-BankCard_cls2__oUSDU ConfirmPayoutDialog-BankCard_cls1__ApaZl"};